module.exports = __webpack_public_path__ + "img/touxiang.0e925915.png";